import { faEnvelope, faPencilAlt, faUserSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Component } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { FormattedDate, FormattedMessage, injectIntl } from "react-intl";
import {
  EDIT_TEMP_USER_DIALOG,
  SHOW_INACTIVE_RESPONDENTS,
  TEMPORARY_USER_ID,
  TEMPORARY_USER_USERNAME
} from "../../../ducks/manageSurveyTempUsers";
import Checkbox from "../../common/Checkbox";

class ManageSurveyTempUserTable extends Component {
  constructor(props) {
    super(props);
    this.onShowInactive = this.onShowInactive.bind(this);
    this.openPopupTempUserLink = this.openPopupTempUserLink.bind(this);
    this.editTempUser = this.editTempUser.bind(this);
    this.openPopupForDeactivation = this.openPopupForDeactivation.bind(this);
    this.renderRow = this.renderRow.bind(this);
  }

  openPopupForDeactivation(name, value, identifier) {
    const { changeProperty } = this.props;
    changeProperty(name, value);
    changeProperty(TEMPORARY_USER_ID, identifier);
  }

  openPopupTempUserLink(name, value, identifier, username) {
    const { changeProperty, getTempUserLink, tempUserList } = this.props;
    changeProperty(name, value);
    changeProperty(TEMPORARY_USER_ID, identifier);
    changeProperty(TEMPORARY_USER_USERNAME, username);
    getTempUserLink(tempUserList, identifier);
  }

  onShowInactive(name, value, refreshRespondentList) {
    const { changeProperty, loadTempUsers, currentOverview, loadRespondentList } = this.props;
    changeProperty(name, value);
    loadTempUsers(currentOverview.projectForeignId);
    if (refreshRespondentList) {
      loadRespondentList();
    }
  }

  editTempUser(name, value, identifier) {
    const { changeProperty, loadTempUser, currentOverview } = this.props;
    changeProperty(name, value);
    changeProperty(TEMPORARY_USER_ID, identifier);
    loadTempUser(identifier, currentOverview.projectForeignId);
  }

  render() {
    const { showInactiveRespondents, tempUserList } = this.props;
    return (
      <Modal.Body>
        <Table striped hover responsive>
          <thead>
            <tr>
              <th>
                <FormattedMessage id="manage.survey.user.name" />
              </th>
              <th>
                <FormattedMessage id="manage.survey.user.lastname" />
              </th>
              <th>
                <FormattedMessage id="manage.survey.user.email" />
              </th>
              <th className="date">
                <FormattedMessage id="manage.survey.user.expiration.date" />
              </th>
              <th className="actions">
                <FormattedMessage id="manage.survey.user.link" />
              </th>
            </tr>
          </thead>
          <tbody>{tempUserList.map(this.renderRow)}</tbody>
        </Table>
        <Checkbox
          name={[SHOW_INACTIVE_RESPONDENTS]}
          defaultChecked={showInactiveRespondents}
          onChange={() => this.onShowInactive(SHOW_INACTIVE_RESPONDENTS, !showInactiveRespondents)}
        >
          <FormattedMessage id="manage.survey.user.inactive.users" />
        </Checkbox>
      </Modal.Body>
    );
  }

  /**
   * Active row renderer
   */
  renderRow(rdRow) {
    const { showInactiveRespondents, intl } = this.props;
    return (
      (rdRow.active || showInactiveRespondents) && (
        <tr key={rdRow.identifier} className={!rdRow.active ? "bg-light" : ""}>
          <td>{rdRow.firstname}</td>
          <td>{rdRow.lastname}</td>
          <td>{rdRow.username}</td>
          <td className="date">
            <FormattedDate value={new Date(rdRow.dateOfValidity)} year="numeric" month="2-digit" day="2-digit" />
          </td>
          <td className="actions">
            {rdRow.active && (
              <Button
                size="sm"
                title={intl.formatMessage({ id: "app.common.action.show" })}
                onClick={() => this.openPopupTempUserLink("showTempUserLink", true, rdRow.identifier, rdRow.username)}
                variant="link"
              >
                <FontAwesomeIcon icon={faEnvelope} />
              </Button>
            )}
            <Button
              size="sm"
              title={intl.formatMessage({ id: "app.common.action.edit" })}
              onClick={() => this.editTempUser(EDIT_TEMP_USER_DIALOG, true, rdRow.identifier)}
              variant="link"
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </Button>
            {rdRow.active && (
              <Button
                size="sm"
                title={intl.formatMessage({ id: "app.common.action.deactivate" })}
                onClick={() => this.openPopupForDeactivation("deactivateTempUser", true, rdRow.identifier)}
                variant="link"
                >
                  <FontAwesomeIcon icon={faUserSlash} />
                </Button>

            )}
          </td>
        </tr>
      )
    );
  }
}

ManageSurveyTempUserTable.propTypes = {
  changeProperty: PropTypes.func,
  showInactiveRespondents: PropTypes.bool,
  currentOverview: PropTypes.object,
  loadTempUsers: PropTypes.func,
  loadTempUser: PropTypes.func,
  getTempUserLink: PropTypes.func,
  loadRespondentList: PropTypes.func,
  tempUserList: PropTypes.array
};
export default injectIntl(ManageSurveyTempUserTable);
